export default __webpack_public_path__ + "static/media/Class-10-State-Science.638a5610.pdf";